import styled from "styled-components";

const BasicButton = styled.button`
  all: unset;
  padding: 0.5rem 1rem;
  background-color: var(--color-sky-500);
  color: var(--color-sky-50);
  cursor: pointer;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-family: inherit;
  display: flex;
  justify-content: center;
  align-items: center;

  // not on mobile
  @media (hover: hover) {
    &:hover {
      background-color: var(--color-sky-600);
    }
  }

  transition: background-color 0.2s ease;
`;

export default BasicButton;
